import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Node } from 'src/app/dto';

// Fallback for a NodeType this build doesn't recognize (forward compatibility / version skew) —
// renders nothing instead of throwing.
@Component({
    selector: 'app-unknown-node',
    templateUrl: './unknown-node.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnknownNodeComponent {
    @Input() node: Node;
}
